import React from 'react'
import {formValueSelector, reduxForm} from 'redux-form'
import {Section, DateField} from 'jbc-front/components/Form'
import Button from 'jbc-front/components/Button'
import FormErrors, {onSubmitFail} from 'jbc-front/components/FormErrors'
import {Label} from 'jbc-front/components/presenters/form/Label'
import {Note} from 'jbc-front/components/presenters/ui/Note'
import {Spacer} from 'jbc-front/components/presenters/Spacer'
import {Notes, SubmitedOn, Name, LaborConsultantFields} from 'FormFields'
import EmployeeName from 'procedures/EmployeeName'
import connectForm from 'reportForms/connectForm'

const formName = 'R62Report'
const selector = formValueSelector(formName)

const Form = reduxForm({
  form: formName,
  enableReinitialize: true,
  onSubmitFail,
})(({submitting, handleSubmit, submitText, employee, needLaborConsultant, procedureStatusId}) => (
  <form onSubmit={handleSubmit}>
    <div className="l-title-wrap">
      <h1 className="m-title-main">雇用保険被保険者転勤届</h1>
      <EmployeeName employee={employee} />
    </div>
    <div className="basic_information">
      <FormErrors />

      <Section title="氏名変更">
        <Note>氏名変更の手続き情報がある場合は直近（過去日）の情報が反映されています</Note>

        <Spacer direction="y" size={20} />

        <Label>変更前氏名</Label>

        <Spacer direction="y" size={10} />

        <Name />
        <DateField name="change_name_date" label="氏名変更年月日" />
      </Section>

      <Section title="申請情報">
        <Notes />
        <SubmitedOn />
        <LaborConsultantFields
          needLaborConsultant={needLaborConsultant}
          procedureStatusId={procedureStatusId}
          reportName={'R62'}
        />
      </Section>
    </div>
    <div className="u-ta-c">
      <Button primary onClick={handleSubmit} disabled={submitting}>
        {submitText}
      </Button>
    </div>
  </form>
))

const connectedForm = connectForm('r62', Form, {
  mapState: (state) => ({
    employee: state.procedureStatuses.current.data.employee || {},
    needLaborConsultant: selector(state, 'need_labor_consultant'),
  }),
})

export default connectedForm
